"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInstance = exports.DefaultConfig = void 0;
const RemoteTxBuilder_1 = require("./builders/RemoteTxBuilder");
const const_1 = require("./const");
const DotBit_1 = require("./DotBit");
const BitIndexer_1 = require("./fetchers/BitIndexer");
exports.DefaultConfig = {
    [const_1.BitNetwork.mainnet]: {
        network: const_1.BitNetwork.mainnet,
        bitIndexerUri: 'https://indexer-v1.did.id',
        remoteTxBuilderConfig: {
            subAccountUri: 'https://subaccount-api.did.id/v1',
            registerUri: 'https://register-api.did.id/v1',
        },
    },
    [const_1.BitNetwork.testnet]: {
        network: const_1.BitNetwork.testnet,
        bitIndexerUri: 'https://test-indexer.did.id',
        remoteTxBuilderConfig: {
            subAccountUri: 'https://test-subaccount-api.did.id/v1',
            registerUri: 'https://test-register-api.did.id/v1',
        }
    },
};
function createInstance(config = {}) {
    const defaultConfig = exports.DefaultConfig[config.network || const_1.BitNetwork.mainnet];
    config = Object.assign({}, defaultConfig, config);
    const dotBitConfig = {
        network: config.network,
        bitIndexer: new BitIndexer_1.BitIndexer({
            uri: config.bitIndexerUri
        }),
        bitBuilder: new RemoteTxBuilder_1.RemoteTxBuilder(config.remoteTxBuilderConfig),
        signer: config.signer,
    };
    return new DotBit_1.DotBit(dotBitConfig);
}
exports.createInstance = createInstance;
//# sourceMappingURL=createInstance.js.map